const INITIAL_STATE = {};

export default function rootReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
